import React from 'react'
import useInitialProps from '../../hooks/useStaticContext'
import ModalWidget from '../organisms/ModalWidget'

const ModalPage = ({ staticContext }) => {
  const { card } = useInitialProps(staticContext)
  return <ModalWidget card={card} />
}

export default ModalPage
